export default __webpack_public_path__ + "static/media/ic_convert_down.0d2df053.svg";